import { useState } from "react";
import { useContent } from "../content/ContentContext";
import { SectionLabel } from "../components/Ui";
import { Reveal } from "../components/Reveal";

function Faq() {
  const [open, setOpen] = useState(0);
  const { content } = useContent();
  return (
    <div className="rounded-2xl border border-line bg-white">
      {content.faqs.map((f, i) => (
        <div key={f.q} className="border-b border-line last:border-0">
          <button
            data-testid={`faq-toggle-${i}`}
            aria-expanded={open === i}
            onClick={() => setOpen(open === i ? -1 : i)}
            className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left sm:px-8"
          >
            <span className="font-serif text-base font-medium text-ink sm:text-lg">{f.q}</span>
            <span aria-hidden="true" className={`text-xl text-accent transition-transform duration-200 ${open === i ? "rotate-45" : ""}`}>+</span>
          </button>
          {open === i && <p className="px-6 pb-6 leading-relaxed text-muted sm:px-8">{f.a}</p>}
        </div>
      ))}
    </div>
  );
}

export default function FaqSection() {
  return (
    <section id="faq" data-testid="section-faq" className="mx-auto max-w-7xl scroll-mt-24 px-4 pb-12 sm:px-6 lg:px-8 lg:pb-20">
      <Reveal>
        <SectionLabel>Frequently asked questions</SectionLabel>
        <div className="mt-8"><Faq /></div>
      </Reveal>
    </section>
  );
}
